import Likes from '@components/Likes';
import {store} from '@components/Test/Context';
import type {ReactElement} from 'react';
import {useContext} from 'react';
import {localize} from '@services/i18n';
import I18n from '@components/I18n';

interface Props {
    maxScore: number;
}

export default function DefaultBinaryResult(props: Props): ReactElement<Props> {
    const {currentState} = useContext(store);

    return (
        <div className="test-result">
            <div className="test-result__title">
                <I18n code="Test_yourResult" /> — {currentState.score}/{props.maxScore}
            </div>
            <div className="test-result__line" />
            <div className="test-result__socials">
                <div className="test-result__socials-label">{localize('Test_shareResult')}</div>
                <Likes classes="js-track_test_like" isHorizontal />
            </div>
        </div>
    );
}
